









































































































































































import { Component, Prop } from "vue-property-decorator"; // eslint-disable-line no-unused-vars
import CdkClassification from "@dpa-connect/dpa-connect-classification";
import SlcNewsItemLong from "../SlcNewsItem/SlcNewsItemLong/SlcNewsItemLong.vue";
import { Link, Place } from "./types.d";

@Component({
  components: {
    CdkClassification
  }
})
export default class CdkNewsItemDetail extends SlcNewsItemLong {
  @Prop({
    type: String,
    required: true
  })
  dateTime!: string;

  @Prop({
    type: String,
    required: true
  })
  by!: string;

  @Prop({
    type: String,
    required: true
  })
  main!: string;

  @Prop({
    type: String,
    required: false
  })
  creditLine?: string;

  @Prop({
    type: Array,
    required: true
  })
  links!: Link[];

  @Prop({
    type: Array,
    required: true
  })
  places!: Place[];

  @Prop({
    type: Array,
    required: true
  })
  edservices!: string[];

  @Prop({
    type: Array,
    required: true
  })
  editorialnotes!: string[];

  @Prop({
    type: Array,
    required: true
  })
  dpaContacts!: any[];

  @Prop({
    type: Array,
    required: true
  })
  dpaContactsText!: string[];

  @Prop({
    type: Boolean,
    required: true
  })
  hasNotes!: boolean;

  @Prop({
    type: Boolean,
    required: true
  })
  // eslint-disable-next-line prettier/prettier
  declare isUrgent: boolean;

  @Prop({
    type: String,
    required: false,
    default: ""
  })
  tooltip?: string;
}
